import {
  CHANGE_LOCALE,
  CHANGE_PROPERTY,
  CHANGE_DOMAINS,
  CHANGE_TIMEZONE,
  CHANGE_CURRENCY,
  CHANGE_USER,
  CHECK_VOUCHER_ENGINE,
  CHANGE_GROUP,
  USER_ROLE,
  CHANGE_CLODBEDS,
  CHANGE_CLODBEDS_CODE,
  CHECK_PIN
} from '../actions';

export const changeLocale = (locale) => {
  localStorage.setItem('currentLanguage', locale);
  return {
    type: CHANGE_LOCALE,
    payload: locale,
  };
};

export const changeProperty = (propertyId) => {
  localStorage.setItem('currentPropertyId', propertyId);
  return {
    type: CHANGE_PROPERTY,
    payload: propertyId,
  };
};

export const changeDomains = (domains) => {
  localStorage.setItem('currentDomains', domains);
  return {
    type: CHANGE_DOMAINS,
    payload: domains,
  };
};

export const changeTimeZone = (timeZone) => {
  localStorage.setItem('timeZone', timeZone);
  return {
    type: CHANGE_TIMEZONE,
    payload: timeZone,
  };
};

export const changeCurrency = (currency) => {
  localStorage.setItem('currency', currency);
  return {
    type: CHANGE_CURRENCY,
    payload: currency,
  };
};

export const changeUser = (email) => {
  localStorage.setItem('email', email);
  return {
    type: CHANGE_USER,
    payload: email,
  };
};
export const CheckVoucherEngine = (val) => {
  localStorage.setItem('isVoucherEngine', val);
  return {
    type: CHECK_VOUCHER_ENGINE,
    payload: val,
  };
}

export const ChangeGroupId = (val) => {
  localStorage.setItem('groupId', val);
  return {
    type: CHANGE_GROUP,
    payload: val,
  };
};

export const Changecloudbeds = (val) => {
  localStorage.setItem('cloudbedsId', val);
  return {
    type: CHANGE_CLODBEDS,
    payload: val,
  };
};


export const ChangeUserRole = (role) => {
  localStorage.setItem('role', role);
  return {
    type: USER_ROLE,
    payload: role,
  };
};

export const ChangeCloudbedsCode = (role) => {
  localStorage.setItem('cloudbedsCode', role);
  return {
    type: CHANGE_CLODBEDS_CODE,
    payload: role,
  };
};

export const checkPin = (role) => {
  localStorage.setItem('checkPin', role);
  return {
    type: CHECK_PIN,
    payload: role,
  };
};

